import { render } from "./clinic-archived-list.vue?vue&type=template&id=7facba44&scoped=true"
import script from "./clinic-archived-list.vue?vue&type=script&lang=js"
export * from "./clinic-archived-list.vue?vue&type=script&lang=js"

import "./clinic-archived-list.vue?vue&type=style&index=0&id=7facba44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7facba44"]])

export default __exports__